import { CustomizeControllerArgs } from './index';
import { AppSettings } from '../utils/app-settings';


export default abstract class BaseCustomizer {
  protected settings: AppSettings;
  protected requestContext: any;
  protected context: any;
  protected config: any;
  protected oktaSignIn: any;
  constructor({ requestContext, context, settings, config, oktaSignIn }: CustomizeControllerArgs) {
    this.requestContext = requestContext;
    this.context = context;
    this.settings = settings;
    this.config = config;
    this.oktaSignIn = oktaSignIn;
  }

  abstract shouldCustomize(): Promise<boolean>;

  abstract customize(): Promise<void>;

  /*
   * Convenience method to perform customizations before the customize logic runs
   *
   */
  async preCustomize(): Promise<void> {
    // Implement pre-customization logic in base classes
  }

  async performCustomization() {
    const shouldCustomize = await this.shouldCustomize();
    if (shouldCustomize) {
      await this.preCustomize();
      await this.customize();
    }
    return shouldCustomize;
  }
}
